export class BufferConverter {
    constructor(encoding = 'json') {
        this.encoding = encoding;
    }
    serialize(property) {
        if (this.encoding === 'json') {
            return property.toJSON();
        }
        return property.toString(this.encoding);
    }
    deserialize(value) {
        if (this.encoding === 'json') {
            return Buffer.from(value.data);
        }
        return Buffer.from(value, this.encoding);
    }
}
//# sourceMappingURL=buffer-converter.js.map